import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const a=t("facebook",i`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_1001_2527)">
                <mask
                    id="mask0_1001_2527"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                >
                    <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1001_2527)">
                    <path
                        d="M16.6539 13.25L17.2093 9.63047H13.7363V7.28164C13.7363 6.29141 14.2214 5.32617 15.7769 5.32617H17.3558V2.24453C17.3558 2.24453 15.923 2 14.5531 2C11.6929 2 9.82335 3.73359 9.82335 6.87187V9.63047H6.64404V13.25H9.82335V22H13.7363V13.25H16.6539Z"
                        fill="#FCFCFC"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_1001_2527">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{a as Facebook};
